import { useState } from 'react';
import { PanelCard, Segmented } from '../../../../components/ui';
import { GLOSSARY, type GlossaryKey } from '../../../../lib/glossary';
import EngagementSubTab from './EngagementSubTab';
import WellbeingSubTab from './WellbeingSubTab';
import InterventionsSubTab from './InterventionsSubTab';

type SubTabKey = 'engagement' | 'wellbeing' | 'interventions';

interface Props {
  gradeId: number;
  sectionId: number | 'all';
  /** "Grade 10 · all sections", for the hint under the title. */
  ctx?: string;
}

const SUB_TABS: Array<{ key: SubTabKey; label: string; help: GlossaryKey }> = [
  { key: 'engagement', label: 'Engagement', help: 'tab_engagement' },
  { key: 'wellbeing', label: 'Wellbeing', help: 'wellbeing_dot' },
  { key: 'interventions', label: 'Interventions', help: 'tab_interventions' },
];

export default function WellbeingTopTab({ gradeId, sectionId, ctx }: Props) {
  const [active, setActive] = useState<SubTabKey>('engagement');
  return (
    <PanelCard
      title="Wellbeing and engagement"
      align="end"
      subtitle={`${ctx ? `${ctx} · ` : ''}from student check-ins, study activity and cases`}
      actions={(
        <Segmented<SubTabKey> tabs scroll label="Wellbeing views" value={active} onChange={setActive}
          options={SUB_TABS.map((t) => ({ key: t.key, label: t.label, help: GLOSSARY[t.help].def }))} />
      )}
    >
      {active === 'engagement' && <EngagementSubTab gradeId={gradeId} sectionId={sectionId} />}
      {active === 'wellbeing' && <WellbeingSubTab gradeId={gradeId} sectionId={sectionId} />}
      {active === 'interventions' && <InterventionsSubTab gradeId={gradeId} sectionId={sectionId} />}
    </PanelCard>
  );
}
